// src/hooks/websocket/config.ts
import { WebSocketConfig } from './types';

export const WS_CONFIG: WebSocketConfig = {
    MAX_RECONNECT_ATTEMPTS: 5,
    RECONNECT_DELAY: 1000,
    MIN_TIME_BETWEEN_RECONNECTS: 5000,
  };